function getCurveProps(_ref) {
  var size = _ref.size,
    thickness = _ref.thickness,
    sum = _ref.sum,
    value = _ref.value,
    root = _ref.root,
    offset = _ref.offset;
  var radius = (size * 0.9 - thickness * 2) / 2;
  var deg = Math.PI * radius * 2 / 100;
  var strokeDasharray = root ? "".concat((100 - sum) * deg, ", ").concat(sum * deg) : "".concat(value * deg, ", ").concat((100 - value) * deg);
  return {
    strokeWidth: thickness,
    cx: size / 2,
    cy: size / 2,
    r: radius,
    transform: root ? "scale(1, -1) translate(0, -".concat(size, ")") : null,
    strokeDasharray: strokeDasharray,
    strokeDashoffset: root ? 0 : offset
  };
}
export { getCurveProps };